import {Directive, HostBinding, HostListener, Output, EventEmitter} from '@angular/core';

@Directive({
  selector: '[appDragAndDrop]'
})
export class DragAndDropDirective {
  @Output() fileDropped = new EventEmitter<any>();

  constructor() { }

  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    // @ts-ignore
    document.querySelector(".dragAndDrop").style.backgroundColor = "lightblue"

  }

  // Dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    // @ts-ignore
    document.querySelector(".dragAndDrop").style.backgroundColor = "rgba(0,0,0,.04)"
  }

  // Drop listener
  @HostListener('drop', ['$event']) public ondrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    // @ts-ignore
    document.querySelector(".dragAndDrop").style.backgroundColor = "rgba(0,0,0,.04)"
    let files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.fileDropped.emit(files); //Emit the files to use them outside of the directive
    }
  }



}
